import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import Wrapper from '../../elements/wrapper';

import { media, TransitionMixin } from '../../helpers';
import BottomWave from '../../../images/waves/home-bottom-wave.inline.svg';

const BrandedBannerContainer = styled.div`
    position: relative;
    z-index: 100;
    .color-bg {
        background-color: #f2f0eb;
        z-index: 100;
        position: relative;

        .title-container {
            text-align: center;
            padding-top: 8vh;
            padding-bottom: 8vh;
            ${media.medium`padding-top: 15vh; padding-bottom: 0vh;`}
            ${media.large`max-width: 50vw;`}
            
            h1 {
                color: #000;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                margin: 0 0 20px;
                font-size: 3rem;
                ${media.xl`font-size: 3.5rem;`}

                p {
                    font-size: 1.4rem;
                    color: #000;
                    margin: 0;
                }
            }

            .btn-container {
                padding-bottom: 40px;
                a {
                    color: #fff;
                    border: none;
                    background-color: #f74d33;
                    font-weight: 700;
                    line-height: 1;
                    padding: 15px 40px;
                    border-radius: 5px;
                    border: 1px solid #f74d33;
                    display: inline-block;
                    text-decoration: none;
                    ${TransitionMixin('.25s')}

                    &:hover {
                        color: #f74d33;
                        background-color: #fff;
                    }
                }
            }
        }
    }

    .svg-container {
        position: relative;
        margin-top: -2px;
        ${media.xl`top: -6vh;`}
        ${media.xxl`top: -12vh; margin-bottom: -8vh;`}
        svg {
            width: 100%;
            height: auto;

            path {
                fill: #f2f0eb;
                stroke: #f2f0eb;
            }
        }

        > .image-container {
            position: relative;
            top: 0;
            left: 0;
            width: 100%;
            max-width: 100%;
            top: -25vh;
            margin-bottom: -20vh;
            ${media.large`position: absolute;top: auto; bottom: 0;margin-bottom: 0;`}
            .gatsby-image-wrapper {
                margin: 0 auto;
                z-index: 100;
                max-width: 90%;
                ${media.small`max-width: 500px;`};
                ${media.large`max-width: 450px;`};
                ${media.laptop`max-width: 550px;`};
            }

            &.wide {
                ${media.large`bottom: 10vh;`}
                .gatsby-image-wrapper {
                    ${media.small`max-width: 650px;`};
                    ${media.large`max-width: 650px;`};
                    ${media.laptop`max-width: 650px;`};
                }
            }
            &.tall {
                /* ${media.large`bottom: 10vh;`} */
                .gatsby-image-wrapper {
                    ${media.small`max-width: 450px;`};
                    ${media.large`max-width: 450px;`};
                    ${media.laptop`max-width: 450px;`};
                }
            }
        }
    }

    .icons-wrapper {
        padding-bottom: 100px;
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;

        .item-container {
            text-align: center;
            flex: 0 0 50%;
            margin-bottom: 30px;
            ${media.small`flex: 0 0 33.33%;`}
            ${media.large`flex: 1;`}

            > .inner-wrap {
                max-width: 90%;
                margin: 0 auto;

                .image-container {
                    margin-bottom: 15px;
                    .gatsby-image-wrapper {
                        margin: 0 auto;
                        max-width: 60px;
                        img {
                            margin: 0 auto;
                            object-fit: contain !important;
                        }
                    }
                }

                .content-container {
                    p {
                        font-size: 0.9rem;
                        color: #000;
                        font-weight: bold;
                        line-height: 1.2;
                        max-width: 180px;
                        margin: 0 auto;
                    }
                }
            }
        }
    }
    .bottom-text-container {
        text-align: center;
        h3 {
            font-size: 2.5rem;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            margin: 0 0 15px;
            color: #000;
        }
        p {
            font-size: 1rem;
            color: #000;
            max-width: 450px;
            margin: 0 auto;
            line-height: 1.5;
        }
    }
`;

const BrandedBanner = ({ content }) => {
    const {
        bannerTitle,
        bannerContent,
        bannerButton,
        bannerImage,
        bannerIcons,
        bottomTextHeadline,
        bottomTextCaption,
        bannerType,
    } = content || {};
    return (
        <BrandedBannerContainer>
            <div className="color-bg">
                <Wrapper className="title-container">
                    <h1>{bannerTitle}</h1>
                    <p>{bannerContent}</p>
                    {bannerButton && (
                        <div className="btn-container">
                            <Link to={bannerButton.url}>
                                {bannerButton.title}
                            </Link>
                        </div>
                    )}
                </Wrapper>
            </div>

            <div className="svg-container">
                <BottomWave />
                {bannerImage && (
                    <Wrapper
                        className="image-container"
                        className={
                            bannerType === 'tall'
                                ? 'tall image-container'
                                : bannerType === 'wide'
                                ? 'wide image-container'
                                : 'image-container'
                        }
                    >
                        <Img
                            fluid={bannerImage.localFile.childImageSharp.fluid}
                        />
                    </Wrapper>
                )}
            </div>

            <Wrapper className="icons-wrapper">
                {bannerIcons &&
                    bannerIcons.map((icon) => {
                        const { iconImage, iconText } = icon || {};

                        return (
                            <div className="item-container">
                                <div className="inner-wrap">
                                    <div className="image-container">
                                        <Img
                                            fluid={
                                                iconImage.localFile
                                                    .childImageSharp.fluid
                                            }
                                        />
                                    </div>
                                    <div className="content-container">
                                        <p>{iconText}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </Wrapper>
            <Wrapper className="bottom-text-container">
                <h3>{bottomTextHeadline}</h3>
                <p>{bottomTextCaption}</p>
            </Wrapper>
        </BrandedBannerContainer>
    );
};

export default BrandedBanner;
